// Laatst bekende portaal-status per gebruiker, zodat het scherm direct goed staat bij openen
const key = (uid) => `ep_cache_${uid || 'anon'}`;

export const readPortalCache = (uid) => {
  try {
    return JSON.parse(localStorage.getItem(key(uid))) || {};
  } catch {
    return {};
  }
};

export const writePortalCache = (uid, patch) => {
  try {
    localStorage.setItem(key(uid), JSON.stringify({ ...readPortalCache(uid), ...patch }));
  } catch {
    /* opslag vol of uitgeschakeld */
  }
};
